ixModuleRouting("impactx.basket", {
    "/basket": {
        template: "<ixa-basket-detail></ixa-basket-detail>",
        templateUrl: "modules/basket/templates/basket.html",
        controller: "BasketCtrl as basketCtrl",
        process: "ViewBasket",
        workspace: "shop",
    },
    "/basket/:id": {
        template: "<ixa-basket-detail></ixa-basket-detail>",
        templateUrl: "modules/basket/templates/basket.html",
        controller: "BasketCtrl as basketCtrl",
        process: "ViewBasket",
        workspace: "shop",
    },
    "/basketlist": {
        template: "<ixa-basket-list></ixa-basket-list>",
        templateUrl: "modules/basket/templates/basketlist.html",
        controller: "BasketListCtrl",
        controllerAs: "basketListCtrl",
        process: "ViewBasket",
        workspace: "shop",
    },
    "/templatelist/:timestamp?": {
        template: "<ixa-basket-template-list></ixa-basket-template-list>",
        templateUrl: "modules/basket/templates/templatelist.html",
        controller: "BasketTemplateListCtrl",
        controllerAs: "basketTemplateListCtrl",
        process: "ViewBasket",
        workspace: "shop",
    },
    "/templateandbasketlist": {
        template: "<ixa-template-and-basket-list></ixa-template-and-basket-list>",
        templateUrl: "modules/basket/templates/templateandbasketlist.html",
        controller: "TemplateAndBasketListCtrl",
        controllerAs: "templateAndBasketListCtrl",
        process: "ViewBasket",
        workspace: "shop",
    },
    "/sendbacklist": {
        template: "<ixa-send-back-basket-list></ixa-send-back-basket-list>",
        templateUrl: "modules/basket/templates/sendbackbasketlist.html",
        controller: "SendBackBasketListCtrl",
        controllerAs: "sendBackBasketListCtrl",
        process: "ViewBasket",
        workspace: "shop",
    },
});
